var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "26px",
    viewBox: "0 0 20 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D6631B0F-68B8-4248-BE93-D7E697855AA0_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elekter---Era---Leping---Expanded",
    transform: "translate(-250.000000, -247.000000)",
    stroke: "#FFCD00",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-3",
    transform: "translate(208.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(19.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L18,0 L18,0 L18,17.7391304 C18,21.1826087 15.1411765,24 11.6470588,24 L0,24 L0,24 L0,0 L0,0 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 6.75,
    x2: 13.5,
    y2: 6.75,
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 11.25,
    x2: 13.5,
    y2: 11.25,
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 15.75,
    x2: 10.5,
    y2: 15.75,
    id: "Stroke-7"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/Icon_Document.3d26e9759ba3f0ce8eb79f091b3635ac.svg";
export { ForwardRef as ReactComponent };